import type { IUserPicture, IUserPicturesGrid } from '@/lib/interface';
import type { PhotoGridPositionsEnum } from '@/lib/enum';
import UserPhotoGrid from './UserPhotoGrid';

export default UserPhotoGrid;

export type TProps = {
	onClickAcceptDenyBtn?: (accept: boolean, userId: string, position: PhotoGridPositionsEnum) => void;
	onClickDeletePictureBtn?: (userId: string, picture: IUserPicture) => void;
	userData: Pick<IUserPicturesGrid, '_id' | 'pictures' | 'verifications'>;
	cardClassName?: string;
	withButtons?: boolean;
	className?: string;
	readonly?: boolean;
};
